import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { appPath } from '../../routes/paths';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="cp-empty-state-page">
      <Result
        status="403"
        title="Access denied"
        subTitle="You do not have permission to view this page. Contact an administrator if you need access."
        extra={
          <Button type="primary" onClick={() => navigate(appPath())}>
            Go to app home
          </Button>
        }
      />
    </div>
  );
};

export default UnauthorizedPage;
